module.exports = __webpack_public_path__ + "img/levelup-icon-confirmation-tick.cab4d776.svg";